// extracted by mini-css-extract-plugin
export default {"form-row":"FormRow_form-row__BIeJD","form-label":"FormRow_form-label__FWohQ","form-input":"FormRow_form-input__P-TqZ"};